/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponse,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderPathParams,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder401,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder404,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder500,
} from "../../types/pecegePayBilletController/GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder.ts";

function getGetApiV1PecegepayBilletCoursefinpersonpaymentidOrderUrl(
  courseFinPersonPaymentId: GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderPathParams["courseFinPersonPaymentId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/pecegepay/billet/${courseFinPersonPaymentId}/order` as const,
  };
  return res;
}

/**
 * @description Retorna os dados do pedido de boleto da parcela informada.
 * @summary Consultar pedido de boleto
 * {@link /api/v1/pecegepay/billet/:courseFinPersonPaymentId/order}
 */
export async function getApiV1PecegepayBilletCoursefinpersonpaymentidOrder(
  courseFinPersonPaymentId: GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderPathParams["courseFinPersonPaymentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder401
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder404
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PecegepayBilletCoursefinpersonpaymentidOrderUrl(
      courseFinPersonPaymentId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
